enum Currency {
  EUR = "eur",
  USD = "usd",
  WMATIC = "wmtc",
  WPOL = "wpol",
  POL = "pol",
}

export default Currency;
